import { Box, Button } from '@mui/material';
import { Icon } from '@sdb/planning-ui';
import { t } from 'i18next';

type FilterButtonProps = {
  handleMoreFilters: () => void;
  showMoreFilters: boolean;
};

const FilterButton = ({
  handleMoreFilters,
  showMoreFilters
}: FilterButtonProps) => {
  return (
    <Box width="max-content" maxWidth={200}>
      <Button
        variant="outlined"
        color="primary"
        sx={{
          width: 'fit-content',
          display: 'flex',
          justifyContent: 'space-between',
          gap: 2.5
        }}
        onClick={handleMoreFilters}
      >
        <Icon type="filter" />
        {showMoreFilters
          ? t('flexHistory.lessFilters')
          : t('flexHistory.moreFilters')}
      </Button>
    </Box>
  );
};

export default FilterButton;
